import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typeahead,
  Menu,
  MenuItem,
  withAsync,
  Highlighter,
} from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "./../../axios";

import defaultProfileIcon from "./profile-icon.png";

const AsyncTypeahead = withAsync(Typeahead);

const SupervisorSearchBar = (props) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const { sessionUser } = useSelector((state) => state.sessionSlice);

  //   const { users, loading } = useSelector(state => state.searchReducer);

  const { handleSelection } = props;

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [query, setQuery] = useState("");
  const client = sessionUser._id;

  const _innerHandleSelection = (value) => {
    if (handleSelection) handleSelection(value[0]);
    setSelectedUsers([]);
  };

  const onSearch = (query) => {
    setQuery(query);
    setLoading(true);
    Axios.get(
      `/api/orgAdmin/search-supervisors?query=${query}&&clientId=${client}`
    )
      .then((res) => {
        //destructure data
        const { results } = res.data;
        setOptions(results);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error :- ", err);
      });
  };

  return (
    <AsyncTypeahead
      id="my-typeahead-id"
      isLoading={loading}
      labelKey={(option) => `${option.firstName} ${option.lastName}`}
      onSearch={onSearch}
      onChange={_innerHandleSelection}
      placeholder={"Search Supervisors using first name or last name"}
      searchText="Searching, please wait..."
      useCache={true}
      selected={selectedUsers}
      options={options}
      renderMenu={(results, menuProps) => renderMenu(results, menuProps, query)}
      filterBy={() => true}
      delay={200}
    />
  );
};

const renderMenu = (results, menuProps, query = "") => {
  return (
    <Menu {...menuProps}>
      {results &&
        results.map((result, idx) => {
          const { firstName, lastName, profilePicUrl } = result;
          return (
            <MenuItem key={idx} option={result} position={idx}>
              <figure key="logo" style={{ float: "left", marginRight: "10px" }}>
                <img
                  src={profilePicUrl || defaultProfileIcon}
                  style={{ maxWidth: "30px", maxHeight: "35px" }}
                  alt="user logo"
                />
              </figure>
              <Highlighter search={query}>
                {`${firstName} ${lastName}`}
              </Highlighter>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="green"
                className="bi bi-person-plus-fill ml-2"
                viewBox="0 0 16 16"
                style={{ float: "right" }}
              >
                <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                <path
                  fillRule="evenodd"
                  d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                />
              </svg>
            </MenuItem>
          );
        })}
    </Menu>
  );
};

export default SupervisorSearchBar;
